import React from 'react';
import { Example } from './apireftypes';
import './examplelanguageselector.css';

type Language = 'curl' | 'javascript' | 'python';

interface Props {
    examples: Example[];
    selectedExampleIndex: number;
    selectedLanguage: Language;
    onExampleChange: (index: number) => void;
    onLanguageChange: (language: Language) => void;
}

export class ExampleLanguageSelector extends React.Component<Props> {
    handleChange(event: React.ChangeEvent<HTMLSelectElement>) {
        const value = event.target.value;
        
        if (value.includes(':')) {
            const [language, indexStr] = value.split(':');
            const index = parseInt(indexStr, 10);
            this.props.onLanguageChange(language as Language);
            this.props.onExampleChange(index);
        } else {
            this.props.onLanguageChange(value as Language);
        }
    }

    render() {
        const { examples, selectedExampleIndex, selectedLanguage } = this.props;
        const languages: Language[] = ['curl', 'javascript', 'python'];

        // Generate options sorted by language first, then example
        const options = languages.flatMap((language) =>
            examples.map((example, index) => {
                let languageLabel: string;
                switch (language) {
                    case 'curl':
                        languageLabel = 'cURL';
                        break;
                    case 'javascript':
                        languageLabel = 'JavaScript';
                        break;
                    case 'python':
                        languageLabel = 'Python';
                        break;
                }
                const label = example.title 
                    ? `${languageLabel}(${example.title})`
                    : languageLabel;
                return {
                    value: `${language}:${index}`,
                    label: label
                };
            })
        );

        return (
            <select
                className="example-language-select"
                value={`${selectedLanguage}:${selectedExampleIndex}`}
                onChange={(e) => this.handleChange(e)}
            >
                {options.map((option, index) => (
                    <option key={index} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        );
    }
}

